import { supabase } from '@/lib/supabase'

export const monthlyReportsRepo = {
  async findAll() {
    const { data, error } = await supabase
      .from('monthly_reports')
      .select(`
        *,
        client:client_id(*)
      `)
      .order('report_month', { ascending: false })

    if (error) throw error
    return data
  },

  async findById(id: string) {
    const { data, error } = await supabase
      .from('monthly_reports')
      .select(`
        *,
        client:client_id(*)
      `)
      .eq('id', id)
      .single()

    if (error) throw error
    return data
  },

  async findByClient(clientId: string) {
    const { data, error } = await supabase
      .from('monthly_reports')
      .select('*')
      .eq('client_id', clientId)
      .order('report_month', { ascending: false })

    if (error) throw error
    return data
  },

  async findByMonth(year: number, month: number) {
    const reportMonth = `${year}-${String(month).padStart(2, '0')}-01`
    const { data, error } = await supabase
      .from('monthly_reports')
      .select(`
        *,
        client:client_id(*)
      `)
      .eq('report_month', reportMonth)

    if (error) throw error
    return data
  },

  async create(data: any) {
    // Use upsert to handle case where report already exists for this client/month
    // This will update the existing report instead of failing with duplicate key error
    const { data: result, error } = await supabase
      .from('monthly_reports')
      .upsert(data as any, {
        onConflict: 'client_id,report_month'
      })
      .select()
      .single()

    if (error) throw error
    return result
  },

  async update(id: string, updates: any) {
    const { data, error } = await supabase
      .from('monthly_reports')
      .update(updates as never)
      .eq('id', id)
      .select()
      .single()

    if (error) throw error
    return data
  },

  async delete(id: string) {
    const { error } = await supabase
      .from('monthly_reports')
      .delete()
      .eq('id', id)

    if (error) throw error
  },
}
